/*
 * View for the branching conversation diagram.
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/topicsSplit/topic/topicDiagramArea/topicDiagram/template/topicDiagramTemplate.html",
], function (Marionette, Messenger, TopicDiagramTemplate) {
  const TopicDiagramView = {};

  // noinspection JSUnusedGlobalSymbols
  TopicDiagramView.topicDiagramView = Marionette.CompositeView.extend({
    template: TopicDiagramTemplate,
    itemViewContainer: "ul",
    tagName: "li",
    events: {
      "click a": function () {
        Messenger.vent.trigger("clicked:diagram", this); //need to use vent instead of view events because the event could be many layers deep (and each layer has itemview: prepended to it)
        return false; //stop link from actually "linking"
      },
      "click #addNode": function () {
        console.log("add node to " + this.model.get("description"));
        Messenger.vent.trigger("add:node", this);
        return false;
      },
      "click #deleteNode": function () {
        console.log("delete node");
        Messenger.vent.trigger("delete:node", this);
        return false;
      },
    },
    highlightNode: function () {
      //keep track of whether it should be highlighted
      this.model.highlighted = true;
      console.log("highlight");
      this.$el.find("a").first().addClass("selected");
      //show add and remove buttons for editable diagrams
      if (!this.readOnly) {
        this.$el.find("#addNode").first().show();
        //dont show remove button for root node
        if (this.model.collection) {
          //checks if model belongs to a collection
          this.$el.find("#deleteNode").first().show();
        }
      }
    },
    unhighlightNode: function () {
      this.model.highlighted = false;
      console.log("unhighlight");
      this.$el.find("a").first().removeClass("selected");
      //hide add and remove buttons
      this.$el.find("#addNode").first().hide();
      this.$el.find("#deleteNode").first().hide();
    },
    initialize: function (options) {
      this.collection = this.model.decisionCol;
      if (options) {
        //if the view is a child of another topicDiagramView
        this.parent = options.parent; //get the parent node's view
        this.readOnly = options.readOnly;
      }
    },
    itemViewOptions: function () {
      return {
        parent: this, //let the children get a reference to the parent object
        readOnly: this.readOnly,
      };
    },
    modelEvents: {
      // Do not listen to the sync event, the module is handling it so that the correct node
      // is selected again
      highlight: "highlightNode",
      unhighlight: "unhighlightNode",
      // Do not render on just any change, otherwise the selection will be lost when the intentId
      // is updated when saving the Topic
      "change:description": "render",
      enter: "render",
    },
    _manage: function () {
      //after we sync the conversation, we need to reinitialize the start node to listen to its new collection
      this.stopListening(this.collection);
      this.initialize();
      this._initialEvents();
      this.render();
    },
    onClose: function () {
      //unhightlight everything when the view is closing
      this.model.highlighted = false;
    },
    onRender: function () {
      this.$el.i18n();
      this.$el
        .find('a[data-toggle="tooltip"], button[data-toggle="tooltip"]')
        .tooltip({ delay: { show: 333, hide: 0 }, container: "body" });
      //rehighlight the node if needed
      if (this.model.highlighted) {
        this.highlightNode();
      }
    },
  });

  return TopicDiagramView;
});
